var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2026_92470)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 25,
    r: 9,
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6406 19.8945C31.0182 19.8945 31.3242 19.5885 31.3242 19.2109C31.3242 18.8334 31.0182 18.5273 30.6406 18.5273C30.2631 18.5273 29.957 18.8334 29.957 19.2109C29.957 19.5885 30.2631 19.8945 30.6406 19.8945Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7718 7.19299L19.7437 10.0827C19.7437 10.0827 19.7437 10.0827 19.7437 10.0827C19.5106 10.415 19.0522 10.4954 18.7199 10.2621C18.7199 10.2621 18.7199 10.2621 18.7199 10.2621L18.7486 10.2212L21.7718 7.19299ZM21.7718 7.19299L25.2312 13.6182C25.3581 13.854 25.6033 14.002 25.8711 14.0047H25.8716H25.8783C26.1433 14.0047 26.388 13.8619 26.5185 13.6307L26.5185 13.6307L32.1963 3.56116L32.3907 4.68729C32.4525 5.04499 32.7631 5.29734 33.1142 5.29726C33.1557 5.29726 33.1978 5.29374 33.2401 5.28641C33.2401 5.28641 33.2401 5.28641 33.2401 5.28641L33.2315 5.23714M21.7718 7.19299L32.9317 0.887027C33.1039 0.989361 33.2228 1.16197 33.2569 1.35939L33.7899 4.44561C33.8543 4.81837 33.6043 5.17275 33.2315 5.23714M33.2315 5.23714C33.1921 5.24398 33.1529 5.24726 33.1142 5.24726C32.787 5.24733 32.4976 5.01211 32.44 4.67879L32.2351 3.49227L33.2315 5.23714Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1881 20.449V13.6401H20.391V30.0702H17.4835C18.5404 28.5276 19.1597 26.6626 19.1597 24.6556C19.1597 23.1477 18.8099 21.7202 18.1881 20.449ZM35.05 9.80605C35.05 9.40014 34.721 9.07109 34.315 9.07109H30.6423C30.2365 9.07109 29.9073 9.40014 29.9073 9.80605V16.1452C29.9073 16.5511 30.2364 16.8802 30.6423 16.8802C31.0482 16.8802 31.3773 16.5511 31.3773 16.1452V10.541H33.5801V30.0702H31.3773V22.2697C31.3773 21.8638 31.0482 21.5347 30.6423 21.5347C30.2364 21.5347 29.9073 21.8638 29.9073 22.2697V30.0701H28.4513V16.9153C28.4513 16.5094 28.1222 16.1803 27.7163 16.1803H24.0435C23.6377 16.1803 23.3085 16.5094 23.3085 16.9153V30.0702H21.8607V12.9051C21.8607 12.4992 21.5317 12.1702 21.1258 12.1702H17.453C17.0471 12.1702 16.718 12.4992 16.718 12.9051V18.2639C14.9579 16.2934 12.3987 15.0508 9.55466 15.0508C4.25865 15.0508 -0.05 19.3594 -0.05 24.6556C-0.05 29.9517 4.25866 34.2604 9.55479 34.2604C12.1536 34.2604 14.5141 33.2224 16.2449 31.5401H34.315C34.7209 31.5401 35.05 31.211 35.05 30.8051C35.05 30.7804 35.0487 30.7561 35.0463 30.7323C35.0487 30.7085 35.05 30.6842 35.05 30.6595V9.80605ZM24.7785 17.6502H26.9814V30.0702H24.7785V17.6502ZM17.6563 25.3905C17.3054 29.2908 14.19 32.4062 10.2898 32.7571V31.683C10.2898 31.2771 9.96071 30.9481 9.55479 30.9481C9.14888 30.9481 8.81983 31.2771 8.81983 31.683V32.7571C4.9196 32.4062 1.80417 29.2908 1.45329 25.3905H2.52731C2.93316 25.3905 3.26228 25.0615 3.26228 24.6556C3.26228 24.2496 2.93323 23.9206 2.52731 23.9206H1.45329C1.80417 20.0203 4.9196 16.9049 8.81983 16.554V17.6281C8.81983 18.034 9.14888 18.363 9.55479 18.363C9.96071 18.363 10.2898 18.034 10.2898 17.6281V16.554C14.1901 16.9049 17.3054 20.0204 17.6563 23.9206H16.5823C16.1764 23.9206 15.8473 24.2496 15.8473 24.6556C15.8473 25.0615 16.1764 25.3905 16.5823 25.3905H17.6563Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9863 23.9703H10.241V20.6068C10.241 20.2285 9.93436 19.9219 9.55605 19.9219C9.17775 19.9219 8.87109 20.2285 8.87109 20.6068V24.6552C8.87109 25.0335 9.17775 25.3402 9.55605 25.3402H12.9863C13.3645 25.3402 13.6712 25.0335 13.6712 24.6552C13.6712 24.2769 13.3646 23.9703 12.9863 23.9703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 3,
    height: 18,
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    width: 3,
    height: 14,
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 4,
    height: 21,
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2026_92470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.deae7234a19c4e5a7a4b318364b656f9.svg";
export { ForwardRef as ReactComponent };